import $ from 'jquery';
import App from './App';

// -- Expose jQuery to window
window.$ = window.jQuery = $;

// -- Boot
document.addEventListener('DOMContentLoaded', () => App.boot());
